(function () {
    if (window.__lkCartUrgencyInstalled) return;
    window.__lkCartUrgencyInstalled = true;
    var duration = 15 * 60 * 1000;
    var storageKey = 'lk-cart-urgency-end';
    var interval = null;

    function getEndTime() {
      try { return Number(sessionStorage.getItem(storageKey)) || 0; } catch (error) { return 0; }
    }
    function setEndTime(value) {
      try { sessionStorage.setItem(storageKey, String(value)); } catch (error) {}
    }
    function format(remaining) {
      var totalSeconds = Math.max(0, Math.ceil(remaining / 1000));
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;
      return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
    }
    function update() {
      var end = getEndTime();
      if (!end) return;
      var remaining = Math.max(0, end - Date.now());
      document.querySelectorAll('[data-lk-cart-timer]').forEach(function (timer) {
        timer.textContent = format(remaining);
        timer.setAttribute('datetime', 'PT' + Math.ceil(remaining / 1000) + 'S');
      });
      if (remaining === 0 && interval) {
        clearInterval(interval);
        interval = null;
      }
    }
    function startWhenOpen() {
      var dialog = document.querySelector('#cart-drawer dialog');
      if (!dialog || !dialog.hasAttribute('open')) return;
      if (!getEndTime()) setEndTime(Date.now() + duration);
      update();
      if (!interval && getEndTime() > Date.now()) interval = setInterval(update, 1000);
    }
    new MutationObserver(startWhenOpen).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });
    document.addEventListener('click', function () { setTimeout(startWhenOpen, 50); }, true);
    startWhenOpen();
})();